<ion-app>
  <ion-split-pane content-id="main-content" [disabled]="!configService.isMenuShown">
    <ion-menu type="reveal" content-id="main-content" [swipeGesture]="configService.isMenuShown" class="ion-no-border">
      <div class="menu-content">
        <div class="logo-wrap">
          <div class="logo">
            <img [src]="'assets/imgs/piscinApp-logo.svg'" alt="PiscinApp Pro" />
            <div>PiscinApp Pro</div>
          </div>
        </div>
        <div class="menu-wrap">
          @if (configService.isMenuShown) {
          <app-navigation-menu></app-navigation-menu>
          }
        </div>
      </div>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
